import api from 'api';
import type { Account, AccountResponse, LogoInternal } from 'types/account';
import { extractDataFromDataURL } from 'utils/file';

export const accountApi = {
  get: (): Promise<Array<AccountResponse>> => {
    return api.get('accounts.json?experiments=true', { accountPrefix: false });
  },
  save: (account: Account): Promise<AccountResponse> => {
    // The backend requires some fields to be remapped on PUT:
    // https://developer.timely.com/internal#update-an-account
    const fixedAccount = {
      ...account,
      company_name: account.name,
      currency_code: account.currency.id,
      weekly_user_capacity: account.capacity.total_hours,
      logo: account.logo as LogoInternal | null | undefined,
      company_size: account.company_size.toString(),
    };
    // The `logo` field is asymmetric on GET/PUT - on GET it is an object containing URLs and
    // metadata about the current logo, while on PUT it is a base64-encoded data string.
    if (fixedAccount.logo?.delete_logo) {
      fixedAccount.logo = 'null' as any;
    } else {
      const logoData = extractDataFromDataURL(account.logo.large_retina);
      if (logoData) {
        fixedAccount.logo = logoData as any;
      } else {
        // Don't include the logo with the request if we aren't going to update it.
        delete fixedAccount.logo;
      }
    }

    return api.put(`accounts/${account.id}`, { account: fixedAccount }, { accountPrefix: false });
  },
  delete: (accountId: number): Promise<unknown> => {
    // Guard against deleting some important prod accounts:
    if ([4301, 795399].includes(accountId)) {
      alert('Close call! You almost managed to delete our production accounts!');
      return Promise.resolve();
    }
    return api.delete(`accounts/${accountId}.json`, undefined, { accountPrefix: false });
  },
};
